import styled from '@emotion/styled';
import { SkeletonBox } from '..';

export const PurpleSpan = styled.span`
  color: ${(props) => props.theme.color.purple.default};
`;

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const FooterProfileImage = styled.img`
  border-radius: 100%;
  width: 44px;
  height: 44px;
  object-fit: cover;
  margin-right: 15px;
`;

export const FooterSkeletonImage = styled(SkeletonBox)`
  border-radius: 100%;
  width: 44px;
  height: 44px;
  margin-right: 15px;
`;

export const FooterTextContainer = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const FooterTitle = styled.div`
  color: ${(props) => props.theme.color.dark.default};
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FooterSubtitle = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ReviewWrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const ReviewText = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

export const WishlistWrapper = styled.div`
  font-size: 20px;
  background: ${(props) => props.theme.color.light.default};
  border-radius: 5px;
  padding: 5px;
  display: flex;
  align-self: center;
  justify-content: center;
`;
